import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import './vendor';
import BjcrxSharedModule from 'app/shared/shared.module';
import BjcrxCoreModule from 'app/core/core.module';
import { NgbDatepickerConfig, NgbDatepickerModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import GlobalErrorHandler from 'app/shared/error-handler';
import moment from 'moment';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import ProfileRxDeletePopupComponent from 'app/entities/profile-rx/profile-rx-delete-dialog/profile-rx-delete-popup.component';
import AuthInterceptor from './blocks/interceptor/auth.interceptor';
import XsrfInterceptor from './xsrf-interceptor';
import AuthExpiredInterceptor from './blocks/interceptor/auth-expired.interceptor';
import ErrorHandlerInterceptor from './blocks/interceptor/errorhandler.interceptor';
import BjcrxAppRoutingModule from './app-routing.module';
import BjcrxHomeModule from './home/home.module';
import BjcrxEntityModule from './entities/entity.module';
import JhiMainComponent from './layouts/main/main.component';
import FooterComponent from './layouts/footer/footer.component';
import PageRibbonComponent from './layouts/profiles/page-ribbon.component';
import ActiveMenuDirective from './layouts/navbar/active-menu.directive';
import ErrorComponent from './layouts/error/error.component';
import VersionCheckService from './version-check.service';
import AppConfigService from './core/app-config.service';

const initAppFn = (appConfigService: AppConfigService) => () => appConfigService.loadConfig();

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    BjcrxSharedModule,
    BjcrxCoreModule,
    BjcrxHomeModule,
    NgxMaskDirective,
    NgbDatepickerModule,
    NgxMaskPipe,
    ToastrModule.forRoot({
      closeButton: false,
      positionClass: 'toast-bottom-full-width',
      disableTimeOut: true,
      tapToDismiss: true,
      preventDuplicates: true
    }),
    BjcrxEntityModule,
    BjcrxAppRoutingModule,
    NgbModule,
    TranslateModule
  ],
  declarations: [
    ProfileRxDeletePopupComponent,
    ErrorComponent,
    PageRibbonComponent,
    ActiveMenuDirective,
    FooterComponent
  ],
  providers: [
    {
      provide: APP_INITIALIZER, useFactory: initAppFn, deps: [AppConfigService], multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XsrfInterceptor,
      multi: true
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    VersionCheckService,
    ToastrService,
    provideNgxMask()
  ],
  exports: [ToastrModule],
  bootstrap: [JhiMainComponent]
})
export default class BjcrxAppModule {
  constructor(private dpConfig: NgbDatepickerConfig) {
    this.dpConfig.minDate = { year: moment().year() - 100, month: 1, day: 1 };
    this.dpConfig.maxDate = { year: moment().year(), month: moment().month() + 1, day: moment().date() };
  }
}
